var exports = {
  "kL": "x7be19a29--634427--container",
  "hP": "x7be19a29--634427--slides",
  "Ie": "x7be19a29--634427--empty",
  "Y5": "x7be19a29--634427--fullscreen",
  "x6": "x7be19a29--634427--button",
};

module.exports = exports;
